import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBaseAlertTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99853 5.99991V8.66658M7.99853 11.3332H8.0052M7.07541 2.59439L1.59216 12.0655C1.28802 12.5908 1.13595 12.8535 1.15843 13.069C1.17803 13.2571 1.27654 13.4279 1.42945 13.5391C1.60475 13.6666 1.90826 13.6666 2.51528 13.6666H13.4818C14.0888 13.6666 14.3923 13.6666 14.5676 13.5391C14.7205 13.4279 14.819 13.2571 14.8386 13.069C14.8611 12.8535 14.709 12.5908 14.4049 12.0655L8.92166 2.59439C8.61861 2.07095 8.46709 1.80923 8.2694 1.72132C8.09696 1.64465 7.90011 1.64465 7.72767 1.72132C7.52998 1.80923 7.37846 2.07095 7.07541 2.59439Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconBaseAlertTriangle;
